import React from 'react';
import Navigation from './Navigation';

const ProductDetailPage = ({ 
  currentUser, 
  currentPage, 
  setCurrentPage, 
  cart, 
  selectedProduct, 
  logout, 
  addToCart 
}) => {
  if (!selectedProduct) {
    return (
      <div className="container">
        <div className="form">
          <p>No product selected.</p>
          <button onClick={() => setCurrentPage('browse')}>
            Back to Browse
          </button>
        </div>
      </div>
    );
  }

  const isInCart = cart.some(item => item.id === selectedProduct.id);
  const isOwnProduct = selectedProduct.sellerId === currentUser.id;

  const handleAddToCart = () => {
    if (!isInCart && !isOwnProduct) {
      addToCart(selectedProduct);
    }
  };

  return (
    <div className="container">
      <div className="header">
        <h1>🌱 EcoFinds</h1>
        <Navigation 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          cart={cart}
          logout={logout}
        />
      </div>
      
      <div className="form">
        <button 
          className="back-button"
          onClick={() => setCurrentPage('browse')}
        >
          ← Back to Browse
        </button>
        
        <div style={{marginTop: '20px'}}>
          <div style={{
            width: '100%', 
            height: '400px', 
            background: '#f0f0f0', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            marginBottom: '20px',
            borderRadius: '8px',
            fontSize: '48px'
          }}>
            📷
          </div>
          
          <div style={{marginBottom: '20px'}}>
            <h1 style={{color: '#2c5530', margin: '0 0 10px 0'}}>{selectedProduct.title}</h1>
            <p className="price" style={{fontSize: '32px', margin: '15px 0', color: '#d32f2f'}}>
              ${selectedProduct.price}
            </p>
          </div>
          
          <div style={{
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
            gap: '15px',
            margin: '20px 0'
          }}>
            <div>
              <p><strong>Category:</strong></p>
              <p style={{color: '#2c5530', fontWeight: 'bold'}}>{selectedProduct.category}</p>
            </div>
            <div>
              <p><strong>Condition:</strong></p>
              <p style={{color: '#2c5530'}}>Used - Good</p>
            </div>
            <div>
              <p><strong>Seller:</strong></p>
              <p style={{color: '#2c5530'}}>
                {isOwnProduct ? 'You' : 'Another User'}
              </p>
            </div>
          </div>
          
          <div style={{margin: '20px 0'}}>
            <h3>Description</h3>
            <p style={{
              background: '#f9f9f9', 
              padding: '15px', 
              borderRadius: '8px',
              lineHeight: '1.6',
              margin: '10px 0'
            }}>
              {selectedProduct.description}
            </p>
          </div>
          
          <div style={{marginTop: '30px'}}>
            {isOwnProduct ? (
              <div>
                <p style={{color: '#666', marginBottom: '15px'}}>
                  This is your listing
                </p>
                <button onClick={() => setCurrentPage('myListings')}>
                  Manage My Listings
                </button>
              </div>
            ) : (
              <div>
                {isInCart ? (
                  <div>
                    <p style={{color: '#2e7d32', marginBottom: '15px'}}>
                      ✓ Already in cart
                    </p>
                    <button onClick={() => setCurrentPage('cart')}>
                      View Cart
                    </button>
                  </div>
                ) : (
                  <button onClick={handleAddToCart}>
                    Add to Cart
                  </button>
                )}
                <button 
                  onClick={() => setCurrentPage('browse')} 
                  style={{background: '#666', marginLeft: '10px'}}
                >
                  Continue Shopping
                </button>
              </div>
            )}
          </div>
          
          <div style={{
            marginTop: '30px', 
            padding: '15px', 
            background: '#e8f5e8', 
            borderRadius: '8px',
            fontSize: '14px'
          }}>
            <h4 style={{color: '#2e7d32', margin: '0 0 10px 0'}}>
              🌱 Sustainable Shopping
            </h4>
            <p style={{color: '#2e7d32', margin: '5px 0'}}>
              By purchasing this pre-owned item, you're helping reduce waste and supporting a circular economy.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailPage;